import React, { useEffect, useState } from "react";
import LUPRecentActivity from "./LUPRecentActivity";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { Card, Col, Container, Form, Placeholder, Row } from "react-bootstrap";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";
import { useParams } from "react-router";
import { BiSolidCube } from "react-icons/bi";

const ModeWiseLUPGraph = ({ StudyMode, selected }) => {
  const { studyId } = useParams();
  const [totalProject, setTotalProject] = useState("");
  const roleType = JSON.parse(localStorage.getItem("role"));
  const [totalProjectLoader, setTotaProjectLoader] = useState(false);

  const getProjectDataForDashboard = async () => {
    setTotaProjectLoader(true);
    let data = await editorProjectServices.getProjectDataForDashboard(
      studyId,
    );
    setTotalProject(data);
    setTotaProjectLoader(false);
  };

  useEffect(() => {
    getProjectDataForDashboard();
  }, [studyId, selected]);
      
  return (
    <>
      <Container fluid>
        <Row>
          {selected.includes("Total Project") && (
            <Form.Group as={Col} md={4} sm={6}>
              <Card className="mb-3 bg-light border">
                <Card.Body>
                  <div className="d-flex gap-3">
                    <div className="study_icopn">
                      <AiOutlineFundProjectionScreen className="bg-white shadow-sm" />
                    </div>
                    <div>
                      <Card.Title>
                        {totalProjectLoader ? (
                          <Placeholder animation="glow">
                            <Placeholder xs={6} style={{ width: 55 }} />
                          </Placeholder>
                        ) : (
                          totalProject?.totalProject || 0
                        )}
                      </Card.Title>
                      <Card.Text className="m-0">Total Project</Card.Text>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Form.Group>
          )}
          {selected.includes("Total Base Package") && (
            <Form.Group as={Col} md={4} sm={6}>
              <Card className="mb-3 bg-light border">
                <Card.Body>
                  <div className="d-flex gap-3">
                    <div className="study_icopn">
                      <BiSolidCube className="bg-white shadow-sm" />
                    </div>
                    <div>
                      <Card.Title>
                        {totalProjectLoader ? (
                          <Placeholder animation="glow">
                            <Placeholder xs={6} style={{ width: 55 }} />
                          </Placeholder>
                        ) : (
                          totalProject?.totalBasePackage || 0
                        )}
                      </Card.Title>
                      <Card.Text className="m-0">Total Base Package</Card.Text>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Form.Group>
          )}
        </Row>
        <Row>
          {roleType === "ctms" && selected.includes("Recent activity") && (
            <Form.Group as={Col} md="12" className="mb-2">
              <Card className="border bg-light">
                <Card.Body>
                  <Card.Title>Recent activity</Card.Title>
                  <Card.Text className="m-0 mt-2">
                    <LUPRecentActivity StudyMode={StudyMode} />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Form.Group>
          )}
        </Row>
      </Container>
    </>
  );
};

export default ModeWiseLUPGraph;
